import { ff } from '@atlassian/jira-feature-flagging';
import getMeta from '@atlassian/jira-get-meta';

/* IMP : Please dont add any script here until you gets go ahead with Thor Team as it might impact TTI of classic Boards & Backlogs */

export const startApps = () => {
	const isGlobalSidebarEnabled = getMeta('ajs-global-sidebar-enabled') === 'true';

	if (isGlobalSidebarEnabled && !ff('deprecate-legacy-jira-quick-filters-package_jee7r')) {
		import(/* webpackChunkName: "async-quick-filters" */ './quick-filters');
	}
};
